import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import "./AdminOrder.css"
import { db } from '../../firebase'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import swal from 'sweetalert';

const AdminOrder = () => {
  const params = useParams()
  const [orderData, setOrderData] = useState(null)
  const [newStatus, setNewStatus] = useState('')

  useEffect(() => {
    db.collection('users').get()
      .then(usersSnapshot => {
        usersSnapshot.forEach(userDoc => {
          // For each user, check their orders collection
          userDoc.ref.collection('orders').doc(params.id).get()
            .then(orderDoc => {
              if (orderDoc.exists) {
                // Retrieve the orderdetails field
                const orderDetails = orderDoc.data();
                orderDetails.customer[0].status && setNewStatus(orderDetails.customer[0].status)
                setOrderData(orderDetails)
              } else {

              }
            })
            .catch(error => {
              console.error("Error retrieving order details: ", error);
            });
        });
      })
      .catch(error => {
        console.error("Error accessing users collection: ", error);
      });
  }, [])

  const updateStatus = () => {
    db.collection('users')
      .doc(orderData.customer[0].email)
      .collection('orders')
      .doc(params.id)
      .update({
        "status": newStatus
      })
      .then(swal("", "Status updated", "success"))
  }

  return (
    <div className='container-fluid admin_order'>
      <h3 className='mt-3 mb-3'>Order id : <small>{params.id}</small></h3>
      <div className='row'>
        <div className='col-lg-8 col-sm-12'>
          <div className='products_ordered'>
            <h4>Products ordered</h4>
            {
              orderData &&
              orderData.basket.map((item, id) =>
                <div key={id} className='row mb-3' style={{ backgroundColor: '#F5F5F5', padding: '10px', width: '98%', justifySelf: 'center', borderRadius: '10px' }}>
                  <div className='col-sm-12 col-md-10 d-flex'>
                    <img src={item.image} width={'90px'} />
                    <div className='d-flex flex-column justify-content-center ml-2'>
                      <span className='font-weight-bold'>{item.title}</span>
                      <span>{item.id}</span>
                    </div>
                  </div>
                  <div className='col-sm-12 col-md-2 d-flex'>
                    <div className='d-flex flex-column justify-content-center'>
                      <span><strong>Price:</strong> {item.price}</span>
                      <span><strong>Qty:</strong> {item.count}</span>
                    </div>
                  </div>
                </div>
              )
            }
            <h5 className='d-flex justify-content-end mr-4'>Total : {orderData&&orderData.amount/100}</h5>
          </div>
        </div>
        <div className='col-lg-4 mt-4 mt-lg-0'>
          <div className='customer'>
            <h4>Customer</h4>
            {
              orderData &&
              orderData.customer !== undefined &&

              <>
                <div className='d-flex'>
                  <AccountCircleIcon style={{ fontSize: '50px' }} />
                  <div className='ml-3'>
                    <strong>{orderData.customer[0].fname} {orderData.customer[0].lname}</strong>
                  </div>
                </div>
                <hr></hr>
                <div className='d-flex flex-column'>
                  <span style={{ color: '#73739c' }}><EmailOutlinedIcon className='mr-2' /> {orderData.customer[0].email}</span>
                  <span style={{ color: '#73739c' }}><PhoneOutlinedIcon className='mr-3' />{orderData.customer[0].contact}</span>
                  <span style={{ color: '#73739c' }}>Address: {orderData.customer[0].address}</span>
                </div></>
            }
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <div className='customer mt-3'>
            <h4>Status</h4>
            <input type='text' value={newStatus} onChange={(e) => setNewStatus(e.target.value)} />
            <button onClick={() => updateStatus()}>update</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOrder
